var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfiler = function SvgProfiler(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.8 8.4c.784 0 1.4.602 1.4 1.4a1.4 1.4 0 0 1-1.4 1.4c-.798 0-1.4-.63-1.4-1.4 0-.798.602-1.4 1.4-1.4M0 0v12.6c0 4.144 3.066 7.7 7.196 8.274C8.064 25.088 11.788 28 16.1 28a9.1 9.1 0 0 0 9.1-9.1v-5.166c1.624-.588 2.8-2.128 2.8-3.934a4.2 4.2 0 1 0-8.4 0c0 1.806 1.176 3.36 2.8 3.934v5.04c0 3.5-2.8 6.3-6.3 6.3-2.8 0-5.152-1.694-5.992-4.214C14 20.02 16.8 16.52 16.8 12.6V0h-5.6v4.2H14v8.4a5.6 5.6 0 0 1-11.2 0V4.2h2.8V0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfiler);
export { ForwardRef as ReactComponent };